// extracted by mini-css-extract-plugin
module.exports = {"balance":"Balance_balance__225sq","balance__title":"Balance_balance__title__1NcFt","balance__value":"Balance_balance__value__2c7AS"};